import { useQuery } from '@tanstack/react-query';
import {
  InspectionsOverviewDto,
  InspectionOverviewDto,
  InspectionState,
} from 'src/api/FiretrolApiClient';
import { inspectionsOverviewApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export type { InspectionsOverviewDto, InspectionOverviewDto };
export { InspectionState };

export function useInspectionsOverview() {
  return useQuery({
    queryKey: queryKeys.inspections.overview(),
    queryFn: ({ signal }) =>
      inspectionsOverviewApiClient.getInspections(toCancelToken(signal)),
    staleTime: 60_000,
    meta: {
      errorContext: 'inspections overview',
    },
  });
}
